import { connect } from 'react-redux'
import { compose } from 'recompose'

import { withImageLoading, withTheme } from 'modules/util'
import { resetBuilder } from '../../../actions'
import argumentTheme from './theme.scss'

export default compose(
  withImageLoading(),
  connect(null, { handleSelect: resetBuilder }),
  withTheme(argumentTheme)
)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Question/Argument/enhancers.js